export const FIND_APPS_BUTTON_SIZE = 32;
export const FILTERS_PANEL_DEFAULT_WIDTH = 340;
export const FILTER_CARD_ANIMATION_DURATION = 200;

export const MAX_CHIPS_GROUP_AMOUNT = 2;

export const FILTER_ITEM_CARD_CLASS_NAME = "filterItemCardWrapper";
